<template>
  <div class="bmv">
    <div>
      <label for="brand">Marque</label>
      <select v-model="brand" id="brand" required>
        <option v-for="brand in brands" :value="brand">{{ brand }}</option>
      </select>
    </div>
    <div>
      <label for="product">Modèle</label>
      <select v-model.number="productId" id="product" required>
        <option v-for="product in filteredProducts" :value="product.id">{{ product.name }}</option>
      </select>
    </div>
    <div>
      <div v-if="products.length > 0 && null !== selectedProduct" v-show="selectedProduct.type === 'variable'">
        <label for="variation">Variation</label>
        <select v-model.number="variationId" id="variation">
          <option v-for="variation in selectedProduct.variations" :value="variation.id">{{
              variation.attributeSummary
            }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandModelVariation",
  data() {
    return {
      brand: '',
      products: [],
      productId: 0,
      variationId: 0,
    }
  },
  computed: {
    brands() {
      return [...new Set(this.products.map(product => product.brand))]
    },
    filteredProducts() {
      if (this.brand.length > 0) {
        return this.products.filter(product => product.brand === this.brand)
      }

      return this.products;
    },
    selectedProduct() {
      if (this.productId > 0) {
        const index = this.products.findIndex(product => product.id === this.productId);
        return this.products[index]
      }

      return null
    },
    attributeSummary() {
      if (this.productId > 0 && this.variationId > 0) {
        const index = this.selectedProduct.variations.findIndex(variation => variation.id === this.variationId);
        return JSON.parse(JSON.stringify(this.selectedProduct.variations[index].attributeSummary))
      }

      return null
    },
    selection() {
      return {
        productId: this.productId,
        variationId: this.variationId,
        productName: this.selectedProduct.name,
        attributeSummary: this.attributeSummary,
      }
    },
  },
  watch: {
    productId() {
      this.$emit('selected', this.selection)
    },
    variationId() {
      this.$emit('selected', this.selection)
    },
  },
  beforeMount() {
    this.$api.get(`g2r/v1/bonus/products/get`)
      .then(response => response.data)
      .then(data => this.products = data)
      .then(() => {
        this.$watch('brand', (val) => {
          if (val.length > 0) {
            this.productId = this.filteredProducts[0].id
          } else {
            this.productId = 0;
          }
        })
        this.$watch('productId', (val) => {
          if (val > 0) {
            if (this.selectedProduct.type === 'variable') {
              this.variationId = this.selectedProduct.variations[0].id;
            } else {
              this.variationId = 0
            }
          } else {
            this.variationId = 0
          }
        })
      })
  },
}
</script>

<style scoped lang="scss">
.bmv {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-column-gap: 2rem;
}
</style>
